// Type of Visit helpers — slug matches the API's tov_key ("Follow-up Visit" → "follow-up-visit").
export const tovSlug = (n) => String(n || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const cleanTovName = (v) => String(v || "").trim().replace(/\s+/g, " ");

export const providerClientId = (p) => String(p?.client_id ?? p?.client_4digit_id ?? "");

export const providersOfClient = (providers, clientId) =>
  providers.filter((p) => providerClientId(p) === String(clientId));

export const tovSlots = (p) => p?.soap_profile?.tov_formats || {};

// providers on this client holding a tov_formats slot for this visit type
export const slotCount = (providers, clientId, name) =>
  providersOfClient(providers, clientId).filter((p) => tovSlots(p)[tovSlug(name)]).length;

// POST /clients/{id}/tov/estimate — shape unconfirmed, read defensively
export function parseEstimate(data) {
  const raw = Array.isArray(data) ? data
    : data?.suggestions || data?.tov_list || data?.visit_types || data?.tovs || data?.names || [];
  const names = raw.map((x) => cleanTovName(typeof x === "string" ? x : x?.name || x?.tov || x?.label)).filter(Boolean);
  const tx = (data?.taxonomies || data?.taxonomy_codes || []).map((t) =>
    typeof t === "string" ? t : [t?.code, t?.desc || t?.description].filter(Boolean).join(" · ")).filter(Boolean);
  return { names: [...new Set(names)], taxonomies: tx };
}

export const DEFAULT_OUTLINE = [
  ["Chief Complaint", "prose"], ["Subjective", "HPI, ROS, history"],
  ["Objective", "vitals, physical exam"], ["Assessment", "problem list"], ["Plan", "orders & follow-up"],
];
